import { gql } from '@apollo/client';

export const TRACK_FIELDS = gql`
  fragment TrackFields on Track {
    track_id
    code
    name
    state
    type
    performance {
      day_of_week
      top_1_win_percentage
      top_1_roi
      value_win_percentage
      value_roi
    }
  }
`;
